<template>
  <div class="message-confirmation mb-4">

    <div class="row row-tabs mt-3">

      <div class="col-12 confirmation-title mb-2">
        <h1 class="text-center"><twemoji :content="option.title"/></h1>
        <button @click="$emit('back')" class="go-back btn-cursor" type="button" name="button">
          <img :src="'./static/img/' + $current_user.role +'/nav_back.png'" alt="">
        </button>
      </div>

      <div class="col-12">
        <div v-for="option in option.contacts" class="single-confirmation confirmed" style="border-bottom: 1px solid #ddd;">
          <p>{{ option.title }}</p>
          <span>Abgestimmt von: {{ option.subtitle }}</span>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  props: ['option'],
};
</script>



// WEBPACK FOOTER //
// src/components/Messages/Show/PollResult.vue